import { checkAuthenticated } from '../../actions/AuthenticationActionCreators';

async function refreshAuthentication(nextState) {
  console.log('Refreshing authentication information');
  const context = nextState.routes[0].getContext();
  await context.executeAction(checkAuthenticated, {routes: nextState.routes});

  console.log('Authentication information updated');
  return {};
}

export default refreshAuthentication;



// WEBPACK FOOTER //
// ./src/utils/route/refreshAuthentication.js